import * as React from 'react'
import { useDriverForm } from '@/modules/drivers/context/DriverFormContext'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { DateField } from '@/ui/form/controls/DateField'
import { TextField } from '@/ui/form/controls/TextField'
import { FieldsetSelect } from '@/modules/settings/components/FieldsetSelect'

import { Divider } from '../../shared/Divider'
import useDriverFieldSetOptions from '../options/useDriverFieldSetOptions'

const IdStage = () => {
  const { t } = useLocalize()
  const { data, setData, countriesOptions, countries } = useDriverForm()
  const { driverIdOptions } = useDriverFieldSetOptions()
  return (
    <div className="tw-flex tw-justify-between">
     <div className="tw-w-full tw-max-w-[256px]">
        <p className="tw-text-lg tw-font-semibold tw-text-content-base">
          {t('driverBasics.identifier')}
        </p>
      </div>
      <div className="tw-flex tw-flex-1 tw-flex-col tw-gap-4">
        <TextField
          label={t('driverBasics.driving-licence-number')}
          value={data?.drivingLicenceNumber}
          onChange={(e) =>
            setData({ ...data, drivingLicenceNumber: e.target.value })
          }
        />
        <Divider />
        <FieldsetSelect
          label={t('driverBasics.identity-document-type')}
          options={driverIdOptions as any}
          value={data?.driverDocumentType ?? ''}
          onChange={(e) =>
            setData({ ...data, driverDocumentType: Number(e.target.value) })
          }
        />

        <TextField
          label={t('driverBasics.document-number')}
          value={data?.driverIdCardNumber}
          onChange={(e) =>
            setData({ ...data, driverIdCardNumber: e.target.value })
          }
        />
        <DateField
          label={t('driverBasics.document-issue-date')}
          value={data?.documentValidFrom}
          setValue={(e) => setData({ ...data, documentValidFrom: e })}
        />

        <DateField
          label={t('driverBasics.document-valid-to')}
          value={data?.documentValidTo}
          setValue={(e) => setData({ ...data, documentValidTo: e })}
        />
        <FieldsetSelect
          label={t('driverBasics.document-issuing-country')}
          placeholder={t('common.select')}
          value={data?.driverIdCardNumberIssuingCountry?.id.toString() ?? ''}
          name={'driverIdCardIssuingCountry'}
          onChange={(e) => {
            const id = e.target.value

            const countryObj = Array.isArray(countries)
              ? countries.find((c) => c.id.toString() === id)
              : null

            setData({
              ...data,
              driverIdCardNumberIssuingCountry: countryObj ?? null,
            })
          }}
          options={countriesOptions}
        />
      </div>
    </div>
  )
}

export default IdStage
